const Header = ({ heading, subHeading, actionButton, tabSelector }) => {
  return (
    <div className="p-4 sm:p-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4 min-w-0">
        {/* <button 
          className="text-gray-600 hover:text-gray-800 transition-colors"
          onClick={() => navigate('/settings')}
        >
          <ChevronLeft className="w-6 h-6" />
        </button> */}
        <div className="text-left flex-grow min-w-0">
          <h1 className="text-2xl font-bold text-gray-600 mb-1 break-words">
            {heading}
          </h1>
          <p className="text-gray-500 mt-2 text-sm italic break-words">
            {subHeading}
          </p>
        </div>
        {actionButton && (
          <div className="w-full sm:w-auto">
            {actionButton}
          </div>
        )}
      </div>
      
      {/* Tab Selector */}
      {tabSelector && (
        <div className="mt-2 min-w-0">
          {tabSelector}
        </div>
      )}
    </div>
  );
};

export default Header;